import React, { useState, useEffect } from "react";
import AuthHeader from "../component/users/Header/AuthHeader";
import { useDispatch } from "react-redux";
import {
  FormControl,
  InputLabel,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Box,
  Typography,
  Checkbox,
  Link,
  FormHelperText,
  FormControlLabel,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Layout from "./common/Layout";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { alpha, InputBase, styled } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../context/auth";
import { useLocation, useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { loginUser } from "../helper/authentication";
import { toast } from "react-toastify";
import { OTP } from "../component/inputs/OtpInput";
import ResetPassForm from "./ResetPassForm";

const Head = styled(Typography)({
  fontWeight: "bold",
  textTransform: `uppercase`,
  fontFamily: "Inter",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "14px",
  lineHeight: "18px",

  color: "#FF7325",
});

const ResetDiv = styled("div")({
  flexGrow: "1",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  maxWidth: "346px",
  padding: "80px 0",
});

const errorTextStyle = {
  backgroundColor: "#00000075",
  color: "red",
  padding: "5px",
  borderRadius: "5px",
};

const ResetPassword = ({ email }) => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [showPass, setShowPass] = useState(false);
  const [showConfPass, setShowConfPass] = useState(false);
  const { login } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [resetPass, setresetPass] = useState(false);

  const handleClickShowPassword = () => setShowPass((show) => !show);
  const handleClickShowConfPassword = () => setShowConfPass((show) => !show);
  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };
  const handleMouseDownConfPassword = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (user != null) {
      dispatch({ type: "SAVE_LOGGED_USER", payload: user?.data });
      login(user?.token);
      navigate(`/`);
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.length == 4) {
      setresetPass(true);
    } else {
      toast.error("Please enter the code.");
    }
  };

  return (
    <>
      {resetPass ? (
        <ResetPassForm code={otp} />
      ) : (
        <Box className="form_wrapper reset">
          <Box className="form_inner">
            <Typography component="h2" className="form_head">
              Enter code
            </Typography>
            <Typography component="p" className="form_sub_head">
              Enter the 4 digit code that we sent on {email}
            </Typography>
            <form
            //  onSubmit={registerForm.handleSubmit}
            >
              <Box className="form reset-form">
                <Box className="reset-div">
                  <OTP
                    length={4}
                    separator={<span> </span>}
                    value={otp}
                    onChange={setOtp}
                  />
                </Box>

                <Button className="Register" onClick={handleSubmit}>
                  Reset Password
                </Button>
              </Box>
            </form>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ResetPassword;
